import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withScriptjs, withGoogleMap, InfoWindow, GoogleMap, Marker } from "react-google-maps"

class Map extends Component {
	constructor(props) {
		super(props);
		this.state = {
			markers: this.props.markers,
			mapProps: this.parseMarkers(this.props.markers),
			colors: ['blue', 'red', 'green', 'yellow', 'pink', 'black']
		};
	}

	static propTypes = {
		markers: PropTypes.array,
		zoom: PropTypes.number,
		infoWindow: PropTypes.bool
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.markers != this.props.markers) {
			var mapProps = this.parseMarkers(nextProps.markers);
			this.setState({ markers: nextProps.markers, mapProps: mapProps });
		}
	}

	parseMarkers(markers) {
		if (markers.length > 1) {
			var v = [];
			var maxLat = 0, minLat = 0, maxLng = 0, minLng = 0, centerLat = 0, centerLng = 0;
			for (let i = 0; i < markers.length; i++) {
				let datos = markers[i];
				centerLat += datos.position.lat;
				centerLng += datos.position.lng;
				if (maxLat < datos.position.lat | maxLat == 0) maxLat = datos.position.lat;
				if (minLat > datos.position.lat | minLat == 0) minLat = datos.position.lat;
				if (maxLng < datos.position.lng | maxLng == 0) maxLng = datos.position.lng;
				if (minLng > datos.position.lng | minLng == 0) minLng = datos.position.lng;
			}
			centerLat = centerLat / markers.length;
			centerLng = centerLng / markers.length;
			var SizeLat = Math.abs(maxLat - minLat);
			var SizeLng = Math.abs(maxLng - minLng);
			var Zoom = Math.floor(Math.log(Math.sqrt(Math.pow(SizeLat, 2) + Math.pow(SizeLng, 2))) * -1.27 + 10);

			centerLat = (maxLat - minLat) / 2 + minLat;
			centerLng = (maxLng - minLng) / 2 + minLng;

			//esto lo genere haciendo una regresión, sacando distancias entre markers y el zoom que necesitaba para verlo
			if (Zoom > 17) Zoom = 17;
			return {
				zoom: Zoom,
				centerLat: centerLat,
				centerLng: centerLng,
			};
		} else if (markers.length === 1) {
			const marker = markers[0];
			return {
				zoom: this.props.zoom,
				centerLat: marker.position.lat,
				centerLng: marker.position.lng,
			};
		} else {
			return {
				zoom: 12,
				centerLat: -38.7183177,
				centerLng: -62.2663478,
			};
		}
	}

	centerChanged() {
		var center = this.map.getCenter();
		var lat = center.lat();
		var lng = center.lng();
		if (lat != this.state.mapProps.centerLat || lng != this.state.mapProps.centerLng) {
			var mapProps = this.state.mapProps;
			mapProps.centerLat = lat;
			mapProps.centerLng = lng;
			this.setState({ mapProps: mapProps });
		}
	}

	zoomChanged() {
		var zoom = this.map.getZoom();
		if (zoom != this.state.mapProps.zoom) {
			var mapProps = this.state.mapProps;
			mapProps.zoom = zoom;
			this.setState({ mapProps: mapProps });
		}
	}

	onToggleOpen(idx) {
		if (this.props.infoWindow) {
			var markers = this.state.markers;
			markers[idx].isOpen = !markers[idx].isOpen;
			this.setState({ markers: markers });
		}
	}

	render() {
		var drawMarkers = [];
		for (let i = 0; i < this.state.markers.length; i++) {
			let mk = this.state.markers[i];
			let Component = mk.Component;
			drawMarkers.push(
				<Marker
					key={i} position={mk.position}
					options={{ polylineOptions: { strokeColor: mk.color } }}
					defaultIcon={(mk.color ? {
						path: "m256.000002,3c-43.351135,0 -78.500002,35.141016 -78.500002,78.500002c0,12.142969 2.759766,23.657447 7.689075,33.914454c0.275731,0.582863 70.810927,138.78555 70.810927,138.78555l69.960183,-137.068362c5.458203,-10.686303 8.539819,-22.798854 8.539819,-35.631641c0,-43.358985 -35.141016,-78.500002 -78.500002,-78.500002zm0,125.600003c-26.010976,0 -47.100001,-21.096875 -47.100001,-47.100001s21.089025,-47.100001 47.100001,-47.100001c26.003126,0 47.100001,21.096875 47.100001,47.100001s-21.096875,47.100001 -47.100001,47.100001z",
						fillColor: mk.color,
						fillOpacity: 1,
						anchor: new google.maps.Point(256, 256),
						strokeWeight: 0.5,
						scale: 0.15
					} : null)}
					onClick={(e) => this.onToggleOpen(i)}
				>
					{mk.isOpen && <InfoWindow onCloseClick={(e) => this.onToggleOpen(i)}>{<Component />}</InfoWindow>}
				</Marker>
			);
		}

		return <GoogleMap
			ref={(map) => { this.map = map; }}
			defaultZoom={this.state.mapProps.zoom}
			zoom={this.state.mapProps.zoom}
			defaultCenter={{ lat: this.state.mapProps.centerLat, lng: this.state.mapProps.centerLng }}
			center={{ lat: this.state.mapProps.centerLat, lng: this.state.mapProps.centerLng }}
			onCenterChanged={() => this.centerChanged()}
			onZoomChanged={() => this.zoomChanged()}
			mapTypeId={this.props.type || 'satellite'}
		>
			{drawMarkers}
		</GoogleMap>
	}
};

const MapWithMarkers = withScriptjs(withGoogleMap(props =>
    <Map {...props} markers={props.markers} />
));

export default MapWithMarkers;


// WEBPACK FOOTER //
// ./src/components/ParadigmaGoogleMap/MapWithMarkers.js